"use client";
import React from "react";
import { Mail, Phone, MapPin, Building2, Users } from "lucide-react";

const contactInfo = [
  {
    label: "Email Us",
    icon: <Mail className="w-7 h-7 stroke-white" />,
    primary: "support@vastainfo.com",
    secondary: "support@vastainfo.com",
    desc: "Get in touch via email for detailed inquiries",
    action: "mailto:support@vastainfo.com",
    backIcon: <Mail className="w-12 h-12 stroke-white" />,
    backText: "Send Email",
  },
  {
    label: "Call Us",
    icon: <Phone className="w-7 h-7 stroke-white" />,
    primary: "+1 678-679-0899",
    secondary: "Available 24/7",
    desc: "Speak directly with our development specialists",
    action: "tel:+16786790899",
    backIcon: <Phone className="w-12 h-12 stroke-white" />,
    backText: "Call Now",
  },
  {
    label: "Visit Us",
    icon: <MapPin className="w-7 h-7 stroke-white" />,
    primary: "2450 Atlanta HWY, Unit 203",
    secondary: "Cumming, GA, 30040, USA",
    desc: "Drop by for a quick discussion or scheduled meeting",
    action: "https://www.google.com/maps/search/?api=1&query=2450+Atlanta+HWY,+Unit+203,+Cumming,+GA,+30040,+USA",
    backIcon: <MapPin className="w-12 h-12 stroke-white" />,
    backText: "Get Directions",
  },
  {
    label: "Follow Us",
    icon: <Users className="w-7 h-7 stroke-white" />,
    primary: "Social Media",
    secondary: "Stay Connected",
    desc: "Follow us for updates and behind-the-scenes content",
    action: null,
    backIcon: <Users className="w-12 h-12 stroke-white" />,
    backText: "Connect With Us",
  },
];

const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
  </svg>
);

const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
  </svg>
);

const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
  </svg>
);

const FlipCard = ({ label, icon, primary, secondary, desc, action, backIcon, backText }) => {
  const handleActionClick = (e) => {
    e.stopPropagation();
    if (action) {
      if (action.startsWith('tel:') || action.startsWith('mailto:')) {
        window.location.href = action;
      } else if (action.startsWith('http')) {
        window.open(action, '_blank', 'noopener,noreferrer');
      }
    }
  };

  const handleSocialClick = (url, e) => {
    e.stopPropagation();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flip-container">
      <div className="flip-card">
        {/* FRONT */}
        <div className="flip-face flip-front">
          <div className="card-top-tab">
            <span>{label}</span>
          </div>
          <div className="icon-circle">{icon}</div>
          <p className="card-title">{label}</p>
          <p className="card-primary">{primary}</p>
          <p className="card-secondary">{secondary}</p>
          <p className="card-desc">{desc}</p>
        </div>

        {/* BACK */}
        <div className="flip-face flip-back">
          {label === "Follow Us" ? (
            <>
              <p className="card-title" style={{ color: "#3b82f6" }}>
                {backText}
              </p>
              <div className="icon-circle">{backIcon}</div>
              <p className="follow-text">Follow us for more...</p>
              <div className="social-row">
                <button
                  onClick={(e) => handleSocialClick("https://www.instagram.com/vastainfo", e)}
                  className="social-btn"
                  aria-label="Follow us on Instagram"
                  type="button"
                >
                  <InstagramIcon />
                </button>
                <button
                  onClick={(e) => handleSocialClick("https://x.com/vastainfoglobal", e)}
                  className="social-btn"
                  aria-label="Follow us on X / Twitter"
                  type="button"
                >
                  <XIcon />
                </button>
                <button
                  onClick={(e) => handleSocialClick("https://www.facebook.com/people/Vasta-Info-Global/100090115755576/", e)}
                  className="social-btn"
                  aria-label="Follow us on Facebook"
                  type="button"
                >
                  <FacebookIcon />
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="card-title" style={{ color: "#3b82f6" }}>
                {backText}
              </p>
              <button
                onClick={handleActionClick}
                className="action-button"
                aria-label={`${backText} - ${primary}`}
                type="button"
              >
                <div className="action-icon-circle">{backIcon}</div>
              </button>
              <p className="action-text">Click to {backText.toLowerCase()}</p>
              <div className="action-details">
                <p className="action-primary">{primary}</p>
                {secondary && <p className="action-secondary">{secondary}</p>}
              </div>
            </>
          )}
        </div>
      </div>

      <style>{`
        .flip-container {
          height: 280px;
          perspective: 800px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
        .flip-card {
          width: 100%;
          height: 100%;
          position: relative;
          transform-style: preserve-3d;
          transition: transform 1500ms cubic-bezier(0.4, 0, 0.2, 1);
        }
        .flip-container:hover .flip-card {
          transform: rotateX(180deg) rotateZ(-180deg);
        }
        .flip-face {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 24px;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 24px 16px 16px;
          background: #ffffff;
          border: 2px solid #3b82f6;
          box-shadow: 0px 8px 25px rgba(59, 130, 246, 0.15);
        }
        .flip-back {
          transform: rotateX(180deg) rotateZ(-180deg);
        }
        .card-top-tab {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 55%;
          height: 32px;
          background: transparent;
          border: 2px solid #3b82f6;
          border-top: none;
          border-radius: 0 0 14px 14px;
          box-shadow: 0px 4px 15px rgba(59, 130, 246, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .card-top-tab span {
          font-size: 11px;
          font-weight: 700;
          color: #3b82f6;
          letter-spacing: 0.5px;
        }
        .icon-circle {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: linear-gradient(135deg, #3b82f6, #60a5fa);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 6px;
          flex-shrink: 0;
        }
        .card-title {
          font-size: 16px;
          font-weight: 700;
          color: #1e293b;
          text-align: center;
          margin: 0;
        }
        .card-primary {
          font-size: 13px;
          font-weight: 600;
          color: #3b82f6;
          text-align: center;
          margin: 0;
          line-height: 1.3;
        }
        .card-secondary {
          font-size: 12px;
          color: #64748b;
          text-align: center;
          margin: 0;
          line-height: 1.3;
        }
        .card-desc {
          font-size: 11px;
          color: #94a3b8;
          text-align: center;
          margin: 0;
          line-height: 1.3;
        }
        .follow-text {
          font-size: 12px;
          font-weight: 500;
          color: #475569;
          margin: 0;
        }
        .social-row {
          display: flex;
          gap: 12px;
          margin-top: 4px;
        }
        .social-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: rgba(59, 130, 246, 0.08);
          border: 1px solid rgba(59, 130, 246, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #3b82f6;
          text-decoration: none;
          transition: background 0.2s, transform 0.2s;
          cursor: pointer;
        }
        .social-btn:hover {
          background: rgba(59, 130, 246, 0.15);
          transform: scale(1.12);
        }
        .action-button {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          transition: transform 0.2s ease;
        }
        .action-button:hover {
          transform: scale(1.1);
        }
        .action-button:focus {
          outline: 2px solid #3b82f6;
          outline-offset: 4px;
          border-radius: 50%;
        }
        .action-icon-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: linear-gradient(135deg, #3b82f6, #60a5fa);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 8px 0;
          flex-shrink: 0;
          box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
        }
        .action-text {
          font-size: 12px;
          font-weight: 500;
          color: #475569;
          margin: 4px 0;
          text-align: center;
        }
        .action-details {
          text-align: center;
          margin-top: 8px;
        }
        .action-primary {
          font-size: 12px;
          font-weight: 600;
          color: #3b82f6;
          margin: 0;
          line-height: 1.3;
        }
        .action-secondary {
          font-size: 11px;
          color: #64748b;
          margin: 2px 0 0 0;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};

const ContactInfoSection = () => {
  return (
    <section
      className="relative py-8 lg:py-12 md:py-10 sm:py-8 bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/40 overflow-hidden"
      aria-labelledby="contact-info-heading"
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-blue-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-indigo-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="container max-w-7xl mx-auto px-4 lg:px-6 md:px-4 sm:px-3 relative">
        {/* Header */}
        <header className="text-center mb-8 lg:mb-12 md:mb-10 sm:mb-8 relative">
          <div
            className="hidden md:block absolute top-20 left-4"
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #60a5fa, #3b82f6)",
              animation: "pulse 2s infinite",
            }}
            aria-hidden="true"
          />

          <div className="inline-flex items-center px-4 py-2 lg:px-6 lg:py-2 md:px-4 md:py-1.5 sm:px-3 sm:py-1 bg-[#1719A8]/90 backdrop-blur-md border border-[#1719A8]/60 rounded-full mb-3 shadow-lg">
            <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
            <span className="text-xs md:text-sm lg:text-sm sm:text-xs text-white font-semibold uppercase tracking-wider">
              Contact Information
            </span>
          </div>

          <h1
            id="contact-info-heading"
            className="text-3xl lg:text-5xl md:text-4xl sm:text-2xl font-bold text-slate-900 mb-4 lg:mb-6 md:mb-5 sm:mb-3 leading-tight"
          >
            MULTIPLE WAYS TO{" "}
            <span className="bg-gradient-to-r from-indigo-600 to-blue-600 bg-clip-text text-transparent">
              REACH US
            </span>
          </h1>

          <div
            className="absolute top-0 right-0"
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
              animation: "bounce 1.8s infinite",
            }}
            aria-hidden="true"
          />

          <p className="text-lg lg:text-xl md:text-lg sm:text-sm text-slate-600 max-w-3xl mx-auto lg:max-w-4xl md:max-w-3xl sm:max-w-xl leading-relaxed border-l-4 border-indigo-600 pl-4 text-left">
            Choose the most convenient way to get in touch with our team. We're
            here to help you bring your project to life.
          </p>
        </header>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 md:gap-10 sm:gap-8 max-w-7xl mx-auto">
          {/* Left Column - Contact Cards */}
          <div className="space-y-6">
            <h2 className="text-2xl lg:text-3xl md:text-2xl sm:text-xl font-bold text-slate-900 mb-6 lg:mb-8 md:mb-6 sm:mb-4">
              Get In Touch
            </h2>

            <div
              className="relative grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6 md:gap-4 sm:gap-3"
              role="list"
              aria-label="Contact information cards"
            >
              {/* Enhanced zig-zag connecting lines for 4 cards */}
              <svg
                className="absolute inset-0 w-full h-full pointer-events-none z-0"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                aria-hidden="true"
              >
                {/* First connecting line - from Email to Call */}
                <path
                  d="M 25% 15% Q 50% 5%, 75% 25%"
                  stroke="#3b82f6"
                  strokeWidth="2"
                  fill="none"
                  strokeDasharray="8,4"
                  strokeLinecap="round"
                  style={{
                    filter: "drop-shadow(0 2px 4px rgba(59, 130, 246, 0.2))",
                    animation: "dashMove 3s linear infinite",
                  }}
                />

                {/* Second connecting line - from Call to Visit */}
                <path
                  d="M 75% 25% Q 50% 40%, 25% 55%"
                  stroke="#60a5fa"
                  strokeWidth="2"
                  fill="none"
                  strokeDasharray="6,3"
                  strokeLinecap="round"
                  style={{
                    filter: "drop-shadow(0 2px 4px rgba(96, 165, 250, 0.2))",
                    animation: "dashMove 3s linear infinite 1s",
                  }}
                />

                {/* Third connecting line - from Visit to Follow */}
                <path
                  d="M 25% 55% Q 50% 70%, 75% 85%"
                  stroke="#3b82f6"
                  strokeWidth="2"
                  fill="none"
                  strokeDasharray="8,4"
                  strokeLinecap="round"
                  style={{
                    filter: "drop-shadow(0 2px 4px rgba(59, 130, 246, 0.2))",
                    animation: "dashMove 3s linear infinite 2s",
                  }}
                />

                {/* Decorative dots at connection points */}
                <circle cx="25%" cy="15%" r="3" fill="#3b82f6" opacity="0.7">
                  <animate
                    attributeName="r"
                    values="3;5;3"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle cx="75%" cy="25%" r="3" fill="#60a5fa" opacity="0.7">
                  <animate
                    attributeName="r"
                    values="3;5;3"
                    dur="2s"
                    repeatCount="indefinite"
                    begin="0.5s"
                  />
                </circle>
                <circle cx="25%" cy="55%" r="3" fill="#3b82f6" opacity="0.7">
                  <animate
                    attributeName="r"
                    values="3;5;3"
                    dur="2s"
                    repeatCount="indefinite"
                    begin="1s"
                  />
                </circle>
                <circle cx="75%" cy="85%" r="3" fill="#60a5fa" opacity="0.7">
                  <animate
                    attributeName="r"
                    values="3;5;3"
                    dur="2s"
                    repeatCount="indefinite"
                    begin="1.5s"
                  />
                </circle>
              </svg>

              {contactInfo.map((info, i) => (
                <div key={i} role="listitem" className="relative z-10">
                  <FlipCard {...info} />
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Map */}
          <div className="space-y-6">
            <h2 className="text-2xl lg:text-3xl md:text-2xl sm:text-xl font-bold text-slate-900 mb-6 lg:mb-8 md:mb-6 sm:mb-4">
              Find Us Here
            </h2>

            <div className="relative">
              {/* Floating dots */}
              <div
                className="absolute -top-4 -right-4 z-10"
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                  animation: "bounce 1.8s infinite",
                }}
                aria-hidden="true"
              />
              <div
                className="absolute -bottom-2 -left-2 z-10"
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #60a5fa, #3b82f6)",
                  animation: "pulse 2s infinite",
                }}
                aria-hidden="true"
              />

              {/* Outer gradient border frame */}
              <div
                className="map-tilt-frame bg-white rounded-3xl p-1 shadow-xl border border-indigo-200/50"
                style={{
                  background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                  transform: "rotate(1.5deg)",
                  transition: "transform 0.5s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "rotate(0deg)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "rotate(1.5deg)")
                }
              >
                <div className="bg-white rounded-[22px] p-4">
                  {/* Map with badge overlay */}
                  <div className="relative">
                    <div
                      className="absolute top-4 left-5 z-10 bg-white/95 backdrop-blur-sm rounded-xl px-3 py-2 flex items-center gap-2 text-sm font-semibold text-slate-800 shadow-lg border border-slate-200/50"
                      aria-label="Location indicator"
                    >
                      <div
                        className="w-2.5 h-2.5 rounded-full bg-red-500"
                        style={{ animation: "pulse 1.4s infinite" }}
                        aria-hidden="true"
                      />
                      We're Here!
                    </div>

                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3313.0234567890123!2d-84.1234567!3d34.2345678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s2450%20Atlanta%20Hwy%2C%20Cumming%2C%20GA%2030040!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                      width="100%"
                      height="600"
                      style={{
                        border: 0,
                        borderRadius: "16px",
                        display: "block",
                      }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Vasta Info - 2450 Atlanta HWY, Unit 203, Cumming, GA"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Keyframe animations */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.3); }
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        @keyframes dashMove {
          0% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 24; }
        }
        @media (max-width: 768px) {
          .flip-container { height: 260px !important; }
        }
        @media (max-width: 640px) {
          .flip-container { height: 240px !important; }
        }
      `}</style>
    </section>
  );
};

export default ContactInfoSection;
